/**
 * Pins a table's bulk-action bar to the bottom of its card.
 *
 * 2 is the only layer over the pinned cells it covers (AntD's
 * `zIndexTableFixed`) and under a row's actions menu at 3; it wins the tie with
 * the cells on tree order, being rendered after the table. Written `z-[2]`
 * because a bare `z-2` the scale stopped emitting would leave the bar at `auto`
 * and keep its spec green.
 */
export const TABLE_BULK_BAR_CLASS = "sticky bottom-0 z-[2]"
